import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper } from "@components";

export const ClientCeoAddress = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);

  return (
    <>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientCeoAdrress)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientCeo.0.data.clientCeoCountry"
          title={trb(i18.Labels.ClientCeoCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientCeo.0.data.clientCeoCity"
          title={trb(i18.Labels.ClientCeoCity)}
        />
      </HalfWidthInputWrapper>

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientCeo.0.data.clientCeoStreet"
          title={trb(i18.Labels.ClientCeoStreet)}
        />
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientCeo.0.data.clientCeoPhone"
          title={trb(i18.Labels.ClientCeoPhone)}
          type="tel"
          defaultValue="+"
        />
      </HalfWidthInputWrapper>
    </>
  );
};
